import util from '@/libs/util.js'

// 阿里云oss的访问路径
export let ossDomain = process.env.VUE_APP_OSS_DOMAIN //'http://hx-oss.nongyouxin.com/'
// 优化为根据环境切换地址
// export let basePath = 'http://127.0.0.1:30002';     //默认为开发环境
// if (process.env.NODE_ENV === 'production') {        //这个判断必须有
// 	/*根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境*/
// 	if (process.env.VUE_APP_FLAG === 'prod') {
// 		//production 生产环境 打包
// 		baseURL = 'http://console.shengxinghuicai.com:30002';
// 		ossDomain = 'https://images.shengxinghuicai.com/'
// 	} 
// 	else if (process.env.VUE_APP_FLAG === 'local') {
// 		// basePath = 'http://console.shengxinghuicai.com:30002'; //线上环境  打包上线时需切换
// 		basePath = 'http://127.0.0.1:30002'; //本地环境
// 	}else if (process.env.VUE_APP_FLAG === 'uat') {
// 		basePath = 'http://192.168.1.250:31002'; //UAT环境
// 	}else if (process.env.VUE_APP_FLAG === 'test') {
// 		basePath = 'http://192.168.1.250:30002'; //test环境
// 		ossDomain = 'https://images.shengxinghuicai.com/'
// 	}
// }
export const sysPath = process.env.VUE_APP_SERVER_URL;

const token = util.cookies.get('token')
//先不做登录获取token，直接写死
// const token = 'cde3e997-499d-4fca-8d04-860e6dcfa475'
// export const  headers= { 'Content-Type': 'application/json' ,"Authorization":"bearer "+token}

